<template>
  <span
      class="badge"
      :class="{
        'bg-dark text-dark': ((errorReason === ' ') && !style && (theme === 'dark')),
        'bg-light text-light': ((errorReason === ' ') && !style && (theme === 'light')),
        'bg-danger': (errorReason !== ' ') && !style,
        [style]: true,
        }"
      style="max-width: 384px;"
  >
    {{ errorReason }}
  </span>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ErrorLabel",
  computed: {
    ...mapState({
      errorReason: state => state.errorLabel.errorReason,
      theme: state => state.theme.theme,
    }),
  },
  props: {
    style: {
      type: [String, Boolean],
      default: false,
    },
  },
}
</script>

<style scoped>

</style>
